<template>
<v-layout row wrap my-5 align-self-start>
    <v-flex xs12 xl8 mb-5>
        <h1 class="display-2 my-2">Admin Dashboard</h1>
    </v-flex>
    <v-flex xs12 md5>
        <v-card>
            <v-card-title class="align-baseline">
                <h2 class="title">Semester Overview</h2>
            </v-card-title>
            <v-data-table :headers="headers" :items="semesters" hide-actions>
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>{{ props.item.name }}</td>
                        <td class="text-xs-center">
                            <v-icon color="green" large v-if="props.item.active">check_circle</v-icon>
                        </td>
                        <td class="text-xs-center">
                            <v-icon color="green" large v-if="props.item.disabled">check_circle</v-icon>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
    </v-flex>
</v-layout>
</template>

<script>
export default {
    data() {
        return {
            headers: [{
                    text: 'Semester',
                    align: 'left',
                    sortable: false,
                    width: '50%',
                    value: 'name'
                },
                {
                    text: 'Active',
                    align: 'center',
                    sortable: false,
                    width: '25%',
                    value: 'active'
                },
                {
                    text: 'Disabled',
                    align: 'center',
                    sortable: false,
                    width: '25%',
                    value: 'disabled'
                },
            ],
        }
    },
    computed: {
        semesters() {
            return this.$store.state.semesterModule.semesters
        }
    }
}
</script>
